<template>
  <div>
    <h1>Modulare Arithmetik</h1>
    <h2>Modulus wählen</h2>
    <p>Bitte wähle einen Modulus zwischen 2 und 25, um die folgenden Visualisierungen der modularen Arithmetik auszuprobieren. Prinzipiell kann man mit beliebig großen Moduli rechnen, jedoch lässt sich ein zu großer Modulus nicht mehr gut visualisieren.</p>
    <div class="small-input">
    <b-field label="Modulus">
      <b-input type="number" min="2" max="25" v-model.number="modulus" />
    </b-field>
    </div>
    <h2>Zahlen modular addieren</h2>
    <ModularArithmetic :modulus="modulus" mode="add" />
    <h2>Zahlen modular subtrahieren</h2>
    <ModularArithmetic :modulus="modulus" mode="sub" />
    <h2>Zahlen modular multiplizieren</h2>
    <p>Um eine Zahl <em>x</em> modular mit <em>n</em> zu multiplizieren, addiert man die Zahl <em>x</em> einfach <em>n</em> mal mit sich selbst. Klingt ineffizient und aufwendig? Es gibt effizientere Wege, die wir aber hier nicht behandeln werden.</p>
    <h2>Zahlen modular dividieren</h2>
    <p>Auch die Division ist bei modularer Arithmetik definiert, jedoch funktioniert sie hier ganz anders, als man es vom Rechnen mit ganzen Zahlen kennt. Mathematiker sprechen bei der Division von einer Multiplikation mit der Inversen. Man dividiert also eine Zahl <em>a</em> durch eine Zahl <em>b</em> (kurz: <em>a</em>/<em>b</em>), indem man <em>a</em> mit der Inversen von <em>b</em> multipliziert (kurz: <em>a</em> &middot; <em>b</em><sup>-1</sup>). Diese Inversen zu berechnen ist nicht trivial, es existiert noch nicht einmal für jede Zahl ein Inverses! Zur Berechnung wird der erweiterte euklidische Algorithmus verwendet.</p>
    <h2>Zahlen modular potenzieren</h2>
    <p>
      Hier verhält es sich ähnlich wie bei der modularen Addition: Um
      <em>a</em><sup><em>b</em></sup>&nbsp;&nbsp;(mod <em>n</em>) zu berechnen,
      multiplizierst du einfach die Zahl <em>a</em> genau <em>b</em> mal mit
      sich selbst. Auch hier gibt es wieder effizientere Verfahren, die im
      übrigen auf gleiche Art und Weise funktionieren, wie bei der
      Multiplikation.
    </p>
  </div>
</template>
<style lang="css">
.small-input {
  width:30%;
}
</style>
<script>
import ModularArithmetic from '@/components/ModularArithmetic.vue'

export default {
  name: 'modulararithmetic',
  components: {
    ModularArithmetic
  },
  data() {
    return {
      modulus: 17,
    }
  }
}
</script>
